/* Kontakt os — kategorier, produktfiltre og klikbare spørgsmål.
   Hører til sections/kontakt-os.liquid.

   Alle spørgsmål ligger i DOM'en fra start og vises/skjules herfra. Det holder
   siden hurtig og gør, at søgemaskiner kan læse dem alle sammen. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.rrKontaktReady === 'true') return;
    root.dataset.rrKontaktReady = 'true';

    var categoryChips = root.querySelectorAll('[data-rr-category]');
    var subWrap = root.querySelector('[data-rr-subchips]');
    var productChips = root.querySelectorAll('[data-rr-product]');
    var questions = root.querySelectorAll('[data-rr-question]');
    var empty = root.querySelector('[data-rr-empty]');
    var message = root.querySelector('[data-rr-message]');

    if (!categoryChips.length) return;

    var activeCategory = 'produkt';
    var activeProduct = null;

    // Første kategori i rækken er den, der er valgt fra start.
    var first = root.querySelector('[data-rr-category][aria-pressed="true"]');
    if (first) activeCategory = first.getAttribute('data-rr-category');

    function press(el, on) {
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function render() {
      Array.prototype.forEach.call(categoryChips, function (chip) {
        press(chip, chip.getAttribute('data-rr-category') === activeCategory);
      });

      // Produktknapperne hører kun til kategori 1.
      var showProducts = activeCategory === 'produkt' && productChips.length > 0;
      if (subWrap) subWrap.hidden = !showProducts;

      Array.prototype.forEach.call(productChips, function (chip) {
        press(chip, chip.getAttribute('data-rr-product') === activeProduct);
      });

      var visible = 0;
      Array.prototype.forEach.call(questions, function (q) {
        var matchesCategory = q.getAttribute('data-rr-cat') === activeCategory;
        var matchesProduct =
          activeCategory !== 'produkt' ||
          !activeProduct ||
          q.getAttribute('data-rr-prod') === activeProduct;
        var show = matchesCategory && matchesProduct;
        q.hidden = !show;
        if (show) visible++;
      });

      if (empty) empty.hidden = visible > 0;
    }

    Array.prototype.forEach.call(categoryChips, function (chip) {
      chip.addEventListener('click', function () {
        activeCategory = chip.getAttribute('data-rr-category');
        activeProduct = null;
        render();
      });
    });

    Array.prototype.forEach.call(productChips, function (chip) {
      chip.addEventListener('click', function () {
        var value = chip.getAttribute('data-rr-product');
        // Klik på det allerede valgte produkt slår filteret fra igen.
        activeProduct = activeProduct === value ? null : value;
        render();
      });
    });

    Array.prototype.forEach.call(questions, function (q) {
      q.addEventListener('click', function () {
        var text = (q.textContent || '').trim();
        if (message) {
          message.value = text;
          message.focus();
          // Markøren placeres til sidst, så kunden kan skrive videre.
          try {
            message.setSelectionRange(text.length, text.length);
          } catch (e) {
            /* nogle browsere tillader det ikke — ligegyldigt */
          }
        }
        Array.prototype.forEach.call(questions, function (other) {
          press(other, other === q);
        });
      });
    });

    render();
  }

  function initAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-rr-kontakt]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Temaeditoren bygger sektionen om, når der rettes i den.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-rr-kontakt]');
    if (root) init(root);
  });
})();
